module.exports = __webpack_public_path__ + "img/kort-12.f15e9b02.png";